.videoContainer {
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background-color: #000000;

	video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.celebrationVideo {
		opacity: 0;
		transition: opacity 0.5s;
	}

	.celebrationVideoVisible {
		opacity: 1;
	}
}
